'use es6';

import { Component } from 'react';
import Raven from 'raven-js';
export default class ErrorBoundary extends Component {
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  componentDidCatch(error, errorInfo) {
    // Log error to LogFetch
    Raven.captureException(error);
    console.error(error);
    console.info(errorInfo.componentStack);
  }
  render() {
    if (this.state.hasError) {
      return null;
    }
    return this.props.children;
  }
}